"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var orderRouter = {
  path: '/order',
  component: _layout.default,
  redirect: '/order/orderManage',
  name: '订单管理',
  alwaysShow: true,
  meta: {
    title: '订单管理',
    icon: 'cuisine'
  },
  children: [{
    path: 'orderManage',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/order/orderManage/index'));
      });
    },
    name: '消费订单',
    meta: {
      title: '消费订单',
      icon: ''
    }
  }, {
    path: 'storeStatistics',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/order/storeStatistics.vue'));
      });
    },
    name: '门店统计',
    meta: {
      title: '门店统计',
      icon: ''
    }
  }, {
    path: 'saleDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/order/saleDetail.vue'));
      });
    },
    name: '明细统计',
    meta: {
      title: '明细统计',
      icon: ''
    }
  }, {
    path: 'invoiceManage',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/order/invoiceManage/index'));
      });
    },
    name: '发票列表',
    meta: {
      title: '发票列表',
      icon: ''
    }
  }]
};
var _default = exports.default = orderRouter;